import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { ExternalLink } from "lucide-react";

const CotacaoPage = () => {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <Header />
      <main className="container mx-auto py-10 px-4">
        <h1 className="text-4xl font-bold mb-8 text-center">Cotações e Carteira Bitcoin</h1>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-10">
          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl">Dólar Hoje</CardTitle>
              <CardDescription>Confira a cotação atual do dólar</CardDescription>
            </CardHeader>
            <CardContent className="flex flex-col items-center">
              <p className="mb-4 text-center">
                Acesse o site Dólar Hoje para verificar a cotação atual do dólar e outras moedas em tempo real.
              </p>
              <Button asChild className="w-full sm:w-auto">
                <a 
                  href="https://dolarhoje.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2"
                >
                  Acessar Dólar Hoje <ExternalLink size={16} />
                </a>
              </Button>
            </CardContent>
          </Card>

          <Card className="shadow-lg">
            <CardHeader>
              <CardTitle className="text-2xl">Coinbase</CardTitle>
              <CardDescription>Carteira Bitcoin e criptomoedas</CardDescription>
            </CardHeader>
            <CardContent className="flex flex-col items-center">
              <p className="mb-4 text-center">
                Crie sua carteira Bitcoin na Coinbase, uma das maiores exchanges de criptomoedas do mundo.
              </p>
              <Button asChild className="w-full sm:w-auto">
                <a 
                  href="https://coinbase.com/join/865ADXT" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center justify-center gap-2"
                >
                  Acessar Coinbase <ExternalLink size={16} />
                </a>
              </Button>
            </CardContent>
          </Card>
        </div>

        <Card className="shadow-lg mb-10">
          <CardHeader>
            <CardTitle className="text-2xl">Minha Carteira Bitcoin</CardTitle>
            <CardDescription>Endereço para transferências</CardDescription>
          </CardHeader>
          <CardContent>
            <div className="bg-muted p-4 rounded-md overflow-x-auto">
              <code className="text-sm sm:text-base break-all">32R2hbBLWS1VavJFtkSoDAaCiVjP6DC2vA</code>
            </div>
            <p className="mt-4 text-center text-sm text-muted-foreground">
              Use este endereço para enviar Bitcoin para minha carteira.
            </p>
          </CardContent>
        </Card>
      </main>
      <Footer />
    </div>
  );
};

export default CotacaoPage;